import './RadioButton.css';
import PropTypes from 'prop-types';

const RadioButton = (props) => {
  console.log('RadioButton props', JSON.stringify(props));
  return (
    <div>
      <fieldset className={'fmc-check ' + props.className}>
        <legend>{props.label}</legend>
        {props.options.map((option) => (
          <label key={option.name}>
            <input
              type="radio"
              name={props.groupName}
              value={option.value}
              onChange={props.onChange}
              checked={props.radioVal === option.value}
            />
            <span>{option.name}</span>
          </label>
        ))}
      </fieldset>
    </div>
  );
};

RadioButton.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  groupName: PropTypes.string,
  radioVal: PropTypes.any,
  label: PropTypes.string
};

export default RadioButton;
